/**
 * Returns the MUI Chip color for a booking status value.
 * @param {string} status - Booking status (processing, finished, cancelled, refunded)
 * @returns {'success' | 'error' | 'warning' | 'default'} MUI Chip color
 */
export function getBookingStatusColor(status) {
    switch (status) {
        case 'finished':
            return 'success';
        case 'cancelled':
            return 'error';
        case 'processing':
        case 'refunded':
            return 'warning';
        default:
            return 'default';
    }
}
